<template>
    <sweet-modal :title="$t('modal_bussinessUnits_businessUnitCantBeDeleted')" blocking ref="disabledProjectsEngagementsModal" v-on:close="closeModal">
        <p v-if="disabledProjects.length && disabledEngagements.length">
            {{$t('modal_bussinessUnits_businessUnitCantBeDeletedAsItAttachedToProjectsAndEngagements')}}
        </p>
        <p v-if="disabledProjects.length && !disabledEngagements.length">
            {{$t('modal_bussinessUnits_businessUnitCantBeDeletedAsItAttachedToProjects')}}
        </p>
        <p v-if="!disabledProjects.length && disabledEngagements.length">
            {{$t('modal_bussinessUnits_businessUnitCantBeDeletedAsItAttachedToEngagements')}}
        </p>
        <div class="projects-table" v-if="disabledProjects.length">
            <el-table
                    :data="disabledProjects"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="name"
                        :label="$t('general_projectName')">
                </el-table-column>
                <el-table-column
                        width="150"
                        :label="$t('settings_businessUnits_operations')">
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                plain
                                type="primary"
                                @click="handleEditProjects(scope.$index, scope.row)">{{$t('modal_bussinessUnits_select')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="projects-table" v-if="disabledEngagements.length">
            <el-table
                    :data="disabledEngagements"
                    border
                    style="width: 100%">
                <el-table-column
                        prop="name"
                        :label="$t('general_engagementName')">
                </el-table-column>
                <el-table-column
                        width="150"
                        :label="$t('settings_businessUnits_operations')">
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                plain
                                type="primary"
                                @click="handleEditEngagements(scope.$index, scope.row)">{{$t('modal_bussinessUnits_select')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </sweet-modal>
</template>

<script>
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: "DisabledProjectsEngagementsModal",
    components: {
      SweetModal
    },
    data(){
      return {
        disabledProjects: [],
        disabledEngagements: []
      }
    },
    methods:{
      openModal(disabledProjects, disabledEngagements){
        this.disabledProjects = disabledProjects;
        this.disabledEngagements = disabledEngagements;
        this.$refs.disabledProjectsEngagementsModal.open();
      },
      handleEditProjects(index, row){
        this.$router.push({name: 'projects', query: { companyId: this.$route.query.companyId, projectId: row.id, taskId: '0' }} )
      },
      handleEditEngagements(index, row){
        this.$router.push({name: 'engagements', query: { companyId: this.$route.query.companyId, engagementId: row.id, taskId: '0' }} )
      },
      closeModal(){
        this.disabledProjects = [];
        this.disabledEngagements = []
      }
    }
  }
</script>

<style scoped>

</style>
